import React from 'react'
import './styles/App.css'
import {ThemeProvider} from '@mui/material'
import {RouterProvider} from 'react-router-dom'

import {Provider} from 'react-redux'
import router from './router'
import {store} from '@/store'
import '@/services/i18n'

import theme from '@/styles/theme/theme'
import NotificationProvider from '@/components/NotificationContext/NotificationProvider'
import ModalProvider from '@/components/ModalContext/ModalProvider'
import ModalAcceptProvider from '@/components/ModalAcceptContext/ModalAcceptProvider'
import LoaderProvider from '@/components/LoaderContext/ModalProvider'
import ErrorBoundaryLocal from '@/pages/ErrorBoundary/ErrorBoundary'
import {ErrorBoundary} from '@sentry/react'
import ErrorModalListener from './components/Modals/ErrorModal/ErrorModalListener'
import {RemoteTooltipProvider} from '@/components/RemoteTooltip/RemoteTooltipProvider'
import {MapProvider} from '@/components/MapContext/MapProvider'

const AppProviders: React.FC<{children: React.ReactNode}> = ({children}) => (
  <ErrorBoundary>
    <ErrorBoundaryLocal>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <NotificationProvider>
            <ModalAcceptProvider>
              <ModalProvider>
                <RemoteTooltipProvider>
                  <MapProvider>{children}</MapProvider>
                </RemoteTooltipProvider>
              </ModalProvider>
            </ModalAcceptProvider>
          </NotificationProvider>
        </ThemeProvider>
      </Provider>
    </ErrorBoundaryLocal>
  </ErrorBoundary>
)

const App: React.FC = () => {
  return (
    <AppProviders>
      <LoaderProvider />
      <RouterProvider router={router} />
      <ErrorModalListener />
    </AppProviders>
  )
}

export default App
